// @flow
import * as React from 'react';
import { AlertItem } from './alert-item';
import { useOutdatedSql } from '../../../../../hooks/use-outdated-sql';
import { useNavigate } from 'react-router-dom';

type Props = {
  agentId?: string
};
export const OutdatedSqlAlert = ({agentId}: Props) => {
  const outdated = useOutdatedSql(agentId)
  const outdatedLength =  outdated?.length;
  const navigate = useNavigate();

  if (!outdatedLength) return null;

  return (
    <AlertItem variant={'filled'} onClick={() => {navigate(`/dashboard/outdated-sql/${agentId}`)}}>
      You have {outdatedLength} SQLs that are dates prior to today's date. Please review and update your Next Contact Date.
    </AlertItem>
  );
};
